import { CartAddEvent } from "@theme/events";

function moveAppToShadowDOM() {
  const app = document.getElementById("app-wrapper");
  console.log("app");
  if (!(app instanceof HTMLElement)) return;

  // Create shadow root
  const shadowRoot = app.attachShadow({ mode: "open" });

  // Move existing children into the shadow root
  let child = app.firstChild;
  while (child) {
    shadowRoot.appendChild(child);
    child = app.firstChild;
  }

  app.style.display = "block"

  console.log("Shadow DOM initialized:", shadowRoot);
}

function toggleVariantSelector() {
  const appWrapper = document.getElementById("app-wrapper");
  if (!(appWrapper instanceof HTMLElement)) return;
  const shadowRoot = appWrapper.shadowRoot;
  if (!shadowRoot) return;
  const container = shadowRoot.querySelector(".portraits-ai-grid");
  if (!(container instanceof HTMLElement)) return;

  const selectedImage = shadowRoot.querySelector("[data-selected-image]");
  console.log(selectedImage, "selectedImage");

  const observer = new MutationObserver((mutations) => {
    console.log("mutations", mutations);
    for (const mutation of mutations) {
      if (mutation.type === "childList" || mutation.type === "attributes") {
        const hasSelectedImage = !!shadowRoot.querySelector(
          "[data-selected-image]"
        );
        container.style.display = hasSelectedImage ? "block" : "none";
      }
    }
  });

  const appRoot = shadowRoot.querySelector("#app");
  if (appRoot) {
    observer.observe(appRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-selected-image"],
    });
  }

  // Initial check
  const hasSelectedImage = !!shadowRoot.querySelector("[data-selected-image]");
  container.style.display = hasSelectedImage ? "block" : "none";
}

function setListeners() {
  const appWrapper = document.getElementById("app-wrapper");
  if (!(appWrapper instanceof HTMLElement)) return;
  const shadowRoot = appWrapper.shadowRoot;
  if (!shadowRoot) return;
  
  // Try to find container in shadow root first, then fallback to regular DOM
  let container = shadowRoot.querySelector(".portraits-ai-grid");
  if (!(container instanceof HTMLElement)) {
    // Fallback: check if it's still in regular DOM (before shadow DOM move)
    container = document.querySelector(".portraits-ai-grid");
  }
  if (!(container instanceof HTMLElement)) return;

  const inputs = /** @type {NodeListOf<HTMLInputElement>} */ (
    container.querySelectorAll('input[type="radio"]')
  );

  // Only set up input listeners if inputs exist (multi-variant products)
  if (inputs.length > 0) {
    inputs.forEach((input) => {
    input.addEventListener("change", (e) => {
      console.log("change fired");
      const inputWrapper = input.closest("div[data-active-class]");
      if (!(inputWrapper instanceof HTMLElement)) return;

      const activeClassValue = inputWrapper.dataset.activeClass;
      if (!activeClassValue) return;
      const activeClass = activeClassValue.split(" ");
      inputs.forEach((radio) => {
        const radioWrapper = radio.closest("div[data-active-class]");
        if (radioWrapper instanceof HTMLElement) {
          radioWrapper.classList.remove(...activeClass);
        }
      });
      inputWrapper.classList.add(...activeClass);

      const title = inputWrapper.querySelector("[data-title]");
      // const description = inputWrapper.querySelector('[data-description]');
      const price = inputWrapper.querySelector("[data-price]");

      const selectedVariant = container.querySelector(
        "[data-selected-variant]"
      );
      const totalPrice = container.querySelector("[data-total-price]");
      if (
        selectedVariant instanceof HTMLElement &&
        title instanceof HTMLElement
      ) {
        selectedVariant.textContent = title.textContent;
      }
      if (totalPrice instanceof HTMLElement && price instanceof HTMLElement) {
        totalPrice.textContent = price.textContent;
      }
    });
    });

    const firstInput = inputs.item(0);
    if (firstInput) {
      firstInput.checked = true;
      firstInput.dispatchEvent(new Event("change"));
    }
  }

  /**
   * @returns {{ selectedVariantId: string, items: Array<{ id: number, quantity: number, properties: Record<string, string> }> }}
   */
  const getSelectedVariantPayload = () => {
    let selectedVariantId;
    
    // Try to get variant from radio input (multi-variant products)
    const selectedVariant = container.querySelector(
      'input[type="radio"]:checked'
    );
    
    if (selectedVariant instanceof HTMLInputElement) {
      selectedVariantId = selectedVariant.value;
    } else {
      // Fallback to single variant ID from data attribute
      const singleVariantId = container.dataset.singleVariantId;
      if (!singleVariantId) {
        throw new Error("No variant selected");
      }
      selectedVariantId = singleVariantId;
    }
    const selectedImage = shadowRoot.querySelector("[data-selected-image]");
    if (!(selectedImage instanceof HTMLImageElement)) {
      throw new Error("No generated portrait selected");
    }

    return {
      selectedVariantId,
      items: [
        {
          id: Number(selectedVariantId),
          quantity: 1,
          properties: {
            __image: selectedImage.src,
          },
        },
      ],
    };
  };

  const addToCartButton = container.querySelector(
    "[data-add-to-cart-button]"
  );
  if (addToCartButton instanceof HTMLButtonElement) {
    addToCartButton.addEventListener("click", async (e) => {
      const addToCartButtonText = container.querySelector(
        "[data-add-to-cart-button-text]"
      );
      addToCartButton.disabled = true;
      try {
        if (addToCartButtonText instanceof HTMLElement) {
          addToCartButtonText.textContent = "Adding to Cart...";
        }
        e.preventDefault();
        const { items, selectedVariantId } = getSelectedVariantPayload();

        const cartItemsComponents =
          document.querySelectorAll("cart-items-component");
        /** @type {string[]} */
        const cartItemComponentsSectionIds = [];
        cartItemsComponents.forEach((item) => {
          if (item instanceof HTMLElement && item.dataset.sectionId) {
            cartItemComponentsSectionIds.push(item.dataset.sectionId);
          }
        });
        const sections = cartItemComponentsSectionIds.join(",");

        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: items,
            sections: sections,
          }),
        });
        const data = await response.json();
        document.dispatchEvent(
          new CartAddEvent({}, selectedVariantId.toString(), {
            itemCount: 1,
            source: "portraits-ai",
            productId: selectedVariantId,
            sections: data.sections,
          })
        );
        
        // Open the cart drawer after adding to cart
        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && 'open' in cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
        
        console.log(data, "data");
      } catch (error) {
        console.error("Failed to add to cart from portraits AI section", error);
      } finally {
        if (addToCartButtonText instanceof HTMLElement) {
          addToCartButtonText.textContent = "Add to Cart";
        }
        addToCartButton.disabled = false;
      }
    });
  }

  const directCheckoutButton = container.querySelector(
    "[data-direct-checkout-button]"
  );

  if (directCheckoutButton instanceof HTMLButtonElement) {
    const directCheckoutButtonText = directCheckoutButton.querySelector(
      "[data-direct-checkout-button-text]"
    );

    directCheckoutButton.addEventListener("click", async (e) => {
      e.preventDefault();
      directCheckoutButton.disabled = true;
      if (directCheckoutButtonText instanceof HTMLElement) {
        directCheckoutButtonText.textContent = "Processing...";
      }

      try {
        const { items, selectedVariantId } = getSelectedVariantPayload();

        // Check if product is already in cart
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();
        
        const isInCart = cartData.items.some(
          /** @param {{ variant_id: number }} item */
          (item) => item.variant_id === Number(selectedVariantId)
        );

        if (!isInCart) {
          // Product is not in cart, add it first
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              items: items,
            }),
          });

          if (!response.ok) {
            throw new Error("Failed to add item for direct checkout");
          }

          await response.json();
        }

        // Redirect to checkout (whether product was already in cart or just added)
        window.location.href = "/checkout";
      } catch (error) {
        console.error("Failed to start direct checkout", error);
        if (directCheckoutButtonText instanceof HTMLElement) {
          directCheckoutButtonText.textContent = "Checkout Now";
        }
        directCheckoutButton.disabled = false;
      }
    });
  }

  const gotAnotherPetButton = container.querySelector(
    "[data-got-another-pet-button]"
  );

  if (gotAnotherPetButton instanceof HTMLButtonElement) {
    gotAnotherPetButton.addEventListener("click", async (e) => {
      e.preventDefault();
      gotAnotherPetButton.disabled = true;

      try {
        // Get the selected variant ID
        let selectedVariantId;
        const selectedVariant = container.querySelector(
          'input[type="radio"]:checked'
        );
        
        if (selectedVariant instanceof HTMLInputElement) {
          selectedVariantId = Number(selectedVariant.value);
        } else {
          // Fallback to single variant ID from data attribute
          const singleVariantId = container.dataset.singleVariantId;
          if (!singleVariantId) {
            throw new Error("No variant selected");
          }
          selectedVariantId = Number(singleVariantId);
        }

        // Check if product is in cart
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();
        
        const isInCart = cartData.items.some(
          /** @param {{ variant_id: number }} item */
          (item) => item.variant_id === selectedVariantId
        );

        if (isInCart) {
          // Product is already in cart, redirect to app page
          window.location.href = window.location.pathname;
        } else {
          // Product is not in cart, show warning modal
          const warningModal = document.getElementById("portraits-warning-modal");
          if (warningModal instanceof HTMLElement) {
            // Function to close modal
            const closeModal = () => {
              warningModal.setAttribute("hidden", "");
              document.body.style.overflow = "";
              gotAnotherPetButton.disabled = false;
            };

            // Show modal
            warningModal.removeAttribute("hidden");
            document.body.style.overflow = "hidden";

            // Handle close button
            const closeButton = warningModal.querySelector(
              "[data-warning-dialog-close]"
            );
            if (closeButton instanceof HTMLButtonElement) {
              closeButton.addEventListener(
                "click",
                closeModal,
                { once: true }
              );
            }

            // Handle cancel button
            const cancelButton = warningModal.querySelector(
              "[data-warning-dialog-cancel]"
            );
            if (cancelButton instanceof HTMLButtonElement) {
              cancelButton.addEventListener(
                "click",
                closeModal,
                { once: true }
              );
            }

            // Handle confirm button
            const confirmButton = warningModal.querySelector(
              "[data-warning-dialog-confirm]"
            );
            if (confirmButton instanceof HTMLButtonElement) {
              confirmButton.addEventListener(
                "click",
                () => {
                  // Redirect to app page (page will reload, so button state doesn't matter)
                  window.location.href = window.location.pathname;
                },
                { once: true }
              );
            }

            // Close modal on backdrop click
            const backdrop = warningModal.querySelector(
              "[data-warning-modal-backdrop]"
            );
            if (backdrop instanceof HTMLElement) {
              backdrop.addEventListener(
                "click",
                closeModal,
                { once: true }
              );
            }

            // Close modal on escape key
            const handleEscape = (/** @type {KeyboardEvent} */ event) => {
              if (event.key === "Escape") {
                closeModal();
                document.removeEventListener("keydown", handleEscape);
              }
            };
            document.addEventListener("keydown", handleEscape, { once: true });
          } else {
            // If modal not found, just redirect
            window.location.href = window.location.pathname;
          }
        }
      } catch (error) {
        console.error("Failed to check cart or show warning", error);
        gotAnotherPetButton.disabled = false;
      }
    });
  }
}

function init() {
  // Wait a second, then move all #app content into a Shadow DOM
  setTimeout(() => {
    moveAppToShadowDOM();
    
    // Retry mechanism to ensure container is found
    const trySetListeners = (attempts = 0) => {
      const appWrapper = document.getElementById("app-wrapper");
      if (!(appWrapper instanceof HTMLElement)) {
        if (attempts < 5) {
          setTimeout(() => trySetListeners(attempts + 1), 200);
        }
        return;
      }
      
      const shadowRoot = appWrapper.shadowRoot;
      if (!shadowRoot && attempts < 5) {
        setTimeout(() => trySetListeners(attempts + 1), 200);
        return;
      }
      
      toggleVariantSelector();
      setListeners();
    };
    
    setTimeout(() => {
      trySetListeners();
    }, 400);
  }, 500);
}

init();
